/* BusyBoard — Montessori Busy Board behaviors (vanilla, Dawn-compatible) */
window.Busyboard = window.Busyboard || {};

(() => {
  const NS = window.Busyboard;

  function initAll() {
    initGalleries();
    initQty();
    initVariantPickers();
    initSticky();
    initAccordions();
    initAtc();
    initVideos();
  }

  function initQty() {
    document.querySelectorAll("[data-bb-qty]").forEach((wrap) => {
      if (wrap.dataset.bbInit) return;
      wrap.dataset.bbInit = "1";
      const minus = wrap.querySelector("[data-bb-qty-minus]");
      const plus = wrap.querySelector("[data-bb-qty-plus]");
      const valueEl = wrap.querySelector("[data-bb-qty-value]");
      let qtyInput = document.querySelector("[data-bb-qty-input]");
      if (!qtyInput) {
        const form = wrap.closest(".busyboard-product-hero__qty-row")
          ? wrap
              .closest(".busyboard-product-hero__qty-row")
              .querySelector("[data-bb-qty-input]")
          : null;
        if (form) qtyInput = form;
      }
      function getQty() {
        return parseInt(valueEl ? valueEl.textContent : "1", 10) || 1;
      }
      function setQty(n) {
        const clamped = Math.max(1, n);
        if (valueEl) valueEl.textContent = String(clamped);
        if (qtyInput) qtyInput.value = String(clamped);
        // sync all qty inputs (hero + sticky if any)
        document.querySelectorAll("[data-bb-qty-input]").forEach((inp) => {
          inp.value = String(clamped);
        });
      }
      if (minus) minus.addEventListener("click", () => setQty(getQty() - 1));
      if (plus) plus.addEventListener("click", () => setQty(getQty() + 1));
    });
  }

  function initGalleries() {
    document.querySelectorAll("[data-bb-gallery]").forEach((root) => {
      if (root.dataset.bbInit) return;
      root.dataset.bbInit = "1";
      const main = root.querySelector("[data-bb-main]");
      const counter = root.querySelector("[data-bb-counter]");
      const thumbs = Array.from(root.querySelectorAll("[data-bb-thumb]"));
      const prev = root.querySelector("[data-bb-prev]");
      const next = root.querySelector("[data-bb-next]");
      const viewport = root.querySelector("[data-bb-thumbs-viewport]");
      const track = root.querySelector("[data-bb-thumbs-track]");
      if (!main) return;
      let active = parseInt(root.dataset.bbActive || "0", 10);
      const total = thumbs.length || parseInt(root.dataset.bbTotal || "1", 10);
      const VISIBLE = 5;

      function clamp(n, min, max) {
        return Math.max(min, Math.min(max, n));
      }

      function updateThumbTrack(idx) {
        if (!track || !thumbs.length) return;
        const count = thumbs.length;
        if (count <= VISIBLE) {
          track.style.transform = "translateX(0)";
          return;
        }
        let pageStart = Math.floor(idx / VISIBLE) * VISIBLE;
        const maxStart = count - VISIBLE;
        if (pageStart > maxStart) pageStart = maxStart;
        if (pageStart < 0) pageStart = 0;
        const first = thumbs[0];
        const gap = parseFloat(getComputedStyle(track).gap) || 8;
        const thumbW = first ? first.offsetWidth : 0;
        const offset = pageStart * (thumbW + gap);
        track.style.transform = "translateX(-" + offset + "px)";
      }

      function update(idx) {
        const count = thumbs.length || total;
        // stop at ends (no loop) per spec
        active = clamp(idx, 0, count - 1);
        root.dataset.bbActive = String(active);
        const dataSrcs = root.dataset.bbSrcs
          ? JSON.parse(root.dataset.bbSrcs)
          : null;
        if (dataSrcs && dataSrcs[active]) {
          if (main.tagName === "IMG") main.src = dataSrcs[active];
          else {
            const img = main.querySelector("img");
            if (img) img.src = dataSrcs[active];
          }
        } else if (thumbs[active]) {
          const btn = thumbs[active];
          const fullSrc = btn.getAttribute("data-full-src");
          const fullSrcset = btn.getAttribute("data-full-srcset");
          const tImg = btn.querySelector("img");
          const src = fullSrc || (tImg ? tImg.src : null);
          if (src) {
            if (main.tagName === "IMG") {
              main.src = src;
              if (fullSrcset) {
                main.setAttribute("srcset", fullSrcset);
                main.setAttribute("sizes", "(max-width: 749px) 100vw, 580px");
              } else if (tImg && tImg.getAttribute("srcset")) {
                main.setAttribute("srcset", tImg.getAttribute("srcset"));
                main.setAttribute("sizes", "(max-width: 749px) 100vw, 580px");
              }
              // keep 4:5 dimensions if available
              const w =
                btn.getAttribute("data-width") ||
                (tImg ? tImg.getAttribute("width") : null);
              const h =
                btn.getAttribute("data-height") ||
                (tImg ? tImg.getAttribute("height") : null);
              if (w) main.setAttribute("width", w);
              if (h) main.setAttribute("height", h);
            } else {
              const img = main.querySelector("img");
              if (img) {
                img.src = src;
                if (fullSrcset) {
                  img.setAttribute("srcset", fullSrcset);
                  img.setAttribute("sizes", "(max-width: 749px) 100vw, 580px");
                }
              }
            }
          }
        }
        thumbs.forEach((t, i) => {
          t.classList.toggle("is-active", i === active);
          t.setAttribute("aria-selected", i === active ? "true" : "false");
        });
        if (counter) counter.textContent = `${active + 1} / ${count}`;
        // keep active thumb visible — reuse main arrows to also shift thumb strip
        updateThumbTrack(active);
        if (prev) {
          prev.disabled = active === 0;
          prev.style.opacity = active === 0 ? "0.35" : "";
          prev.style.pointerEvents = active === 0 ? "none" : "";
        }
        if (next) {
          next.disabled = active === count - 1;
          next.style.opacity = active === count - 1 ? "0.35" : "";
          next.style.pointerEvents = active === count - 1 ? "none" : "";
        }
      }
      thumbs.forEach((t, i) => t.addEventListener("click", () => update(i)));
      if (prev) prev.addEventListener("click", () => update(active - 1));
      if (next) next.addEventListener("click", () => update(active + 1));
      root.addEventListener("bb:variantChange", (e) => {
        const idx =
          e.detail && typeof e.detail.galleryIndex !== "undefined"
            ? e.detail.galleryIndex
            : null;
        if (idx !== null) update(idx);
      });
      window.addEventListener("resize", () => updateThumbTrack(active));
      update(active);
    });
  }

  function initVariantPickers() {
    document.querySelectorAll("[data-bb-variant-picker]").forEach((picker) => {
      if (picker.dataset.bbInit) return;
      picker.dataset.bbInit = "1";

      const jsonEl = picker.querySelector("[data-bb-variants]");
      let variants = [];
      try {
        variants = JSON.parse(jsonEl.textContent.trim());
      } catch (_) {
        variants = [];
      }
      if (jsonEl) {
        jsonEl.hidden = true;
        jsonEl.style.display = "none";
      }

      const pills = Array.from(picker.querySelectorAll("[data-bb-variant]"));
      const gallery = document.querySelector("[data-bb-gallery]");

      function formatMoney(cents) {
        if (window.Shopify && window.Shopify.formatMoney) {
          try {
            return window.Shopify.formatMoney(
              cents,
              window.Shopify.money_format || "${{amount}}",
            );
          } catch (_) {}
        }
        return "$" + (cents / 100).toFixed(2);
      }

      function norm(s) {
        return (s || "").toString().trim().toLowerCase();
      }

      function findVariantByValue(val) {
        const low = norm(val);
        let v = variants.find((x) => norm(x.option1) === low);
        if (v) return v;
        v = variants.find(
          (x) => norm(x.option1).includes(low) || low.includes(norm(x.option1)),
        );
        if (v) return v;
        v = variants.find(
          (x) => norm(x.title) === low || norm(x.title).includes(low),
        );
        if (v) return v;
        // title may be "Blue / Something" – check option2/option3 as fallback
        v = variants.find(
          (x) => norm(x.option2) === low || norm(x.option3) === low,
        );
        if (v) return v;
        return variants[0] || null;
      }

      function updateByValue(val) {
        const v = findVariantByValue(val);
        const normVal = (val || "").toString().trim();
        const normLow = norm(normVal);
        // live queries so sticky + hero stay in sync after re-render
        const liveInputs = Array.from(
          document.querySelectorAll("[data-bb-variant-input]"),
        );
        const allPriceEls = Array.from(
          document.querySelectorAll("[data-bb-price]"),
        );
        const allCompareEls = Array.from(
          document.querySelectorAll("[data-bb-compare]"),
        );
        if (v) {
          allPriceEls.forEach((el) => {
            el.textContent = formatMoney(v.price);
          });
          allCompareEls.forEach((el) => {
            if (v.compare && v.compare > v.price) {
              el.textContent = formatMoney(v.compare);
              el.hidden = false;
              el.style.display = "";
            } else {
              el.textContent = "";
              el.hidden = true;
              el.style.display = "none";
            }
          });
          liveInputs.forEach((inp) => {
            inp.value = v.id;
          });
        }
        const labelEl =
          picker.querySelector("[data-bb-selected-label]") ||
          document.querySelector("[data-bb-selected-label]");
        if (labelEl) labelEl.textContent = normVal;
        const livePills = Array.from(
          document.querySelectorAll("[data-bb-variant]"),
        );
        const liveSticky = Array.from(
          document.querySelectorAll("[data-bb-sticky-variant]"),
        );
        livePills.forEach((p) => {
          const pv = norm(p.dataset.value) || norm(p.dataset.valueLow);
          const isActive = pv === normLow;
          p.classList.toggle("is-active", isActive);
          p.setAttribute("aria-checked", isActive ? "true" : "false");
        });
        liveSticky.forEach((s) => {
          const isActive = norm(s.dataset.value) === normLow;
          s.classList.toggle("is-active", isActive);
        });
        if (gallery) {
          const gIdxAttr = livePills.find(
            (p) =>
              norm(p.dataset.value) === normLow ||
              norm(p.dataset.valueLow) === normLow,
          );
          const gIdx = gIdxAttr
            ? parseInt(gIdxAttr.dataset.galleryIndex || "0", 10)
            : 0;
          gallery.dispatchEvent(
            new CustomEvent("bb:variantChange", {
              detail: { galleryIndex: gIdx },
            }),
          );
        }
        const allAtc = Array.from(document.querySelectorAll("[data-bb-atc]"));
        if (v) {
          allAtc.forEach((atc) => {
            if (v.available === false) {
              atc.disabled = true;
              atc.textContent = window.variantStrings
                ? window.variantStrings.soldOut
                : "Sold out";
            } else {
              atc.disabled = false;
              atc.innerHTML = "ADD TO CART";
            }
          });
        }
      }

      pills.forEach((btn) => {
        btn.addEventListener("click", () => {
          const val = btn.dataset.value || "";
          updateByValue(val);
        });
      });
      // sticky variants are outside picker; bind via delegated live handler as well
      document.querySelectorAll("[data-bb-sticky-variant]").forEach((btn) => {
        if (btn.dataset.bbStickyBound) return;
        btn.dataset.bbStickyBound = "1";
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const val = btn.dataset.value || "";
          updateByValue(val);
        });
      });

      const activePill =
        picker.querySelector("[data-bb-variant].is-active") ||
        picker.querySelector(".is-active[data-bb-variant]") ||
        pills[0];
      if (activePill) updateByValue(activePill.dataset.value || "");
    });
  }

  function initSticky() {
    const sticky = document.querySelector("[data-bb-sticky]");
    if (!sticky) return;
    if (sticky.dataset.bbInit) return;
    sticky.dataset.bbInit = "1";
    const threshold = 700;
    function onScroll() {
      const show = window.scrollY > threshold;
      sticky.classList.toggle("is-visible", show);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  function initAccordions() {
    document.querySelectorAll("[data-bb-accordion]").forEach((root) => {
      if (root.dataset.bbInit) return;
      root.dataset.bbInit = "1";
      const btns = root.querySelectorAll("[data-accordion-btn]");
      btns.forEach((btn) => {
        btn.addEventListener("click", () => {
          const expanded = btn.getAttribute("aria-expanded") === "true";
          const single = root.dataset.accordionSingle === "true";
          if (single && !expanded) {
            btns.forEach((b) => {
              if (b !== btn) {
                b.setAttribute("aria-expanded", "false");
                const p = document.getElementById(
                  b.getAttribute("aria-controls"),
                );
                if (p) p.hidden = true;
              }
            });
          }
          btn.setAttribute("aria-expanded", String(!expanded));
          const panel = document.getElementById(
            btn.getAttribute("aria-controls"),
          );
          if (panel) panel.hidden = expanded;
        });
      });
    });
  }

  function initVideos() {
    document.querySelectorAll("[data-bb-video]").forEach((root) => {
      if (root.dataset.bbInitVideo) return;
      const btn = root.querySelector(".busyboard-product-hero__video-play");
      if (!btn) return;
      root.dataset.bbInitVideo = "1";
      const video = root.querySelector("video");
      const external = root.querySelector("[data-bb-video-external]");

      function pauseOthers() {
        document
          .querySelectorAll("[data-bb-video].is-playing")
          .forEach((other) => {
            if (other === root) return;
            other.classList.remove("is-playing");
            const v = other.querySelector("video");
            if (v) {
              v.pause();
              v.controls = false;
            }
            const iframe = other.querySelector(
              "[data-bb-video-external] iframe",
            );
            if (iframe) iframe.remove();
          });
      }

      function playHosted() {
        if (!video) return;
        pauseOthers();
        root.classList.add("is-playing");
        video.controls = true;
        video.muted = false;
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
      }

      function playExternal() {
        if (!external) return;
        if (external.querySelector("iframe")) return;
        pauseOthers();
        const provider = external.dataset.provider;
        const id = external.dataset.videoId;
        let src = "";
        if (provider === "youtube")
          src = "https://www.youtube.com/embed/" + id + "?autoplay=1&rel=0";
        else if (provider === "vimeo")
          src = "https://player.vimeo.com/video/" + id + "?autoplay=1";
        if (!src) return;
        const iframe = document.createElement("iframe");
        iframe.src = src;
        iframe.setAttribute(
          "allow",
          "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen",
        );
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("title", "Product video");
        iframe.loading = "lazy";
        iframe.style.cssText =
          "position:absolute;inset:0;width:100%;height:100%;border:0;";
        external.style.position = "absolute";
        external.style.inset = "0";
        external.appendChild(iframe);
        root.classList.add("is-playing");
      }

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (video) playHosted();
        else if (external) playExternal();
      });
      root.addEventListener("click", (e) => {
        if (e.target.closest(".busyboard-product-hero__video-play")) return;
        if (root.classList.contains("is-playing")) return;
        if (video) playHosted();
        else if (external) playExternal();
      });
      if (video) {
        video.addEventListener("ended", () => {
          root.classList.remove("is-playing");
          video.controls = false;
        });
      }
    });
  }

  function initAtc() {
    const forms = document.querySelectorAll("[data-bb-atc-form]");
    forms.forEach((form) => {
      if (form.dataset.bbInit) return;
      form.dataset.bbInit = "1";
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const btn = form.querySelector("[data-bb-atc]");
        const origHTML = btn ? btn.innerHTML : "";
        if (btn) {
          btn.disabled = true;
          btn.textContent = "Adding…";
        }
        const fd = new FormData(form);
        if (!fd.get("quantity")) fd.set("quantity", "1");
        // sync quantity from hero qty display if form quantity is stale
        const qtyEl = document.querySelector("[data-bb-qty-value]");
        if (qtyEl && fd.get("quantity") === "1") {
          const liveQty = parseInt(qtyEl.textContent, 10);
          if (liveQty > 1) fd.set("quantity", String(liveQty));
        }
        try {
          const res = await fetch(window.routes.cart_add_url + ".js", {
            method: "POST",
            headers: { Accept: "application/json" },
            body: fd,
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || "Add to cart failed");
          }
          try {
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) {
              const secRes = await fetch(
                `${window.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`,
              );
              if (secRes.ok) {
                const data = await secRes.json().catch(() => null);
                if (data) {
                  if (data["cart-drawer"] && cartDrawer) {
                    const temp = document.createElement("div");
                    temp.innerHTML = data["cart-drawer"];
                    const newDrawer = temp.querySelector("cart-drawer");
                    if (newDrawer) cartDrawer.innerHTML = newDrawer.innerHTML;
                    const drawerComp = document.querySelector("cart-drawer");
                    if (drawerComp && typeof drawerComp.open === "function")
                      drawerComp.open();
                    else if (cartDrawer.querySelector("details"))
                      cartDrawer.querySelector("details").open = true;
                  }
                  const bubble = document.querySelector("#cart-icon-bubble");
                  if (bubble && data["cart-icon-bubble"]) {
                    const tb = document.createElement("div");
                    tb.innerHTML = data["cart-icon-bubble"];
                    const nb = tb.querySelector("#cart-icon-bubble");
                    if (nb) bubble.innerHTML = nb.innerHTML;
                  }
                }
              }
            } else {
              document.dispatchEvent(
                new CustomEvent("cart:refresh", { bubbles: true }),
              );
            }
          } catch (_) {}
          showToast(form.dataset.bbToast || "Added to cart", false);
          const drawer = document.querySelector("cart-drawer");
          if (drawer && drawer.open) {
            try {
              drawer.open();
            } catch (_) {}
          }
        } catch (err) {
          const msg = err && err.message ? err.message : "Error";
          showToast(msg, true);
        } finally {
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = origHTML;
          }
        }
      });
    });
  }

  function showToast(text, isError) {
    const el = document.createElement("div");
    el.className = "busyboard-toast";
    el.setAttribute("role", "status");
    el.setAttribute("aria-live", "polite");
    el.innerHTML =
      (isError
        ? ""
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg>') +
      "<span>" +
      escapeHtml(text) +
      "</span>";
    document.body.appendChild(el);
    setTimeout(() => {
      el.style.opacity = "0";
      el.style.transition = "opacity 0.3s";
      setTimeout(() => el.remove(), 300);
    }, 2600);
  }

  function escapeHtml(s) {
    const d = document.createElement("div");
    d.textContent = s;
    return d.innerHTML;
  }

  NS.initAll = initAll;
  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();
